import Axios, { AxiosInstance } from 'axios';
// Only include token if running on localhost
const isLocalhost =
  typeof window !== 'undefined' && window.location.hostname === 'localhost';

// const token = isLocalhost
const token = true ? '17|o5xTFDLUwesHZ1Ggdyry39TI81j15GyMhe2PNi4C' : null; //
const axios: AxiosInstance = Axios.create({
  baseURL: process.env.NEXT_PUBLIC_BACKEND_URL as string,
  headers: {
    ...(token && { Authorization: `Bearer ${token}` }),
    'X-Requested-With': 'XMLHttpRequest',
  },
  withCredentials: true,
  withXSRFToken: true,
});
export default axios;

// import Axios, { AxiosInstance } from 'axios';
// const token = '234667|jdKbytWRBzV0gRleoe3Ez59Ed5XM30d0tbtuoMys';
// const axios: AxiosInstance = Axios.create({
//   baseURL: process.env.NEXT_PUBLIC_BACKEND_URL as string,
//   headers: {
//     'X-Requested-With': 'XMLHttpRequest',
//     // Authorization: `Bearer ${token}`,
//   },
//   withCredentials: true,
//   withXSRFToken: true,
// });
// export default axios;
